module.exports = "/assets/f98c0c40e8cc61dbca359e7820d4e0b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/S4.png
// module id = 2929
// module chunks = 0